// src/pages/home/index.js
import React from 'react'
import './style.css'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import Typewriter from 'typewriter-effect'
import { introdata, meta } from '../../content_option'
import { Link } from 'react-router-dom'

export const Home = () => {
  return (
    <HelmetProvider>
      <section id='home' className='home'>
        <Helmet>
          <meta charSet='utf-8' />
          <title> {meta.title}</title>
          <meta name='description' content={meta.description} />
        </Helmet>
        <div className='intro_sec d-block d-lg-flex align-items-center '>
          <div
            className='h_bg-image order-1 order-lg-2 h-100 '
            style={{ backgroundImage: `url(${introdata.img_url})` }}
          ></div>
          <div className='text order-2 order-lg-1 h-100 d-lg-flex justify-content-center'>
            <div className='intro mx-auto'>
              <Link className='title mb-1x'>{introdata.title}</Link>
              <div className='mb-1x'>
                <Typewriter
                  options={{
                    strings: [introdata.description],
                    autoStart: true,
                    loop: true,
                    deleteSpeed: 10,
                  }}
                />
              </div>
              <div className='d-flex'>
                <ul className='list mb-1x'>
                  <li>
                    <Link className='d-flex justify-content-start' to='/blog'>
                      {introdata.links.blog}
                      <div className='arrow'>→</div>
                    </Link>
                  </li>
                  <li>
                    <Link
                      className='d-flex justify-content-start'
                      to='/projects'
                    >
                      {introdata.links.projects}
                      <div className='arrow'>→</div>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </HelmetProvider>
  )
}
